import { ArticleEntity, EditArticle, EditArticleAppProps } from "../editArticle/editArticle.js"
import { GridCustomToolBarButton } from "../core/components/toolBar.js";
import { Grid } from "../core/components/grid.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Helper } from "../core/util/helper.js";
import { General } from "../../siteManagement/general.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { FullHeightContainer } from "../core/components/FullHeighContainer.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { AssemblyGroupViewElement, getFilteredGridData, setOptions } from "../baugruppen/assemblyGroupViewElements.js";
import ProjectMaterialOverview, { ProjectMaterialOverviewProps } from "./projectMaterialOverview.js";
import { OpenEditArticleDialog } from "../editArticle/editArticleDialog.js";
import { ProjectAppProps } from "./project.js";
import { AppMaterialState } from "../resourcePlanning/resourcePlanningMaterial.js";
import { GridArticle } from "../tasks/workPackage/workPackage.js";
import { Article } from "../commonInterfaces.js";
import { openStockSearch } from "../stock/openStockSearch.js";
import { Config } from "../core/config/config.js";
import React from "react";
export default class MaterialGrid extends React.Component<ProjectAppMaterialGridProps, ProjectAppMaterialState>{
    private gridData: ProjectArticleViewModel[] = [];
    private gridOptions: kendo.ui.GridOptions;
    private dataUrl: string;
    private activateButton: boolean;
    private enableUnpacked: boolean;

    private warehouseActive = Config.settings.warehouseActive;

    private NEW_BTN_ID: string = "new";
    private WAREHOUSE_BTN_ID = "warehouse";
    private EDIT_BTN_ID: string = "edit";
    private DELETE_BTN_ID: string = "delete";
    private UNPACK_BTN_ID: string = "unpack";
    private MATERIAL_OVERVIEW_BTN_ID: string = "materialOverview";

    private ASSIGNMENT_BACKGROUND_COLOR = "#bbdefb";
    private WAREHOUSE_BACKGROUND_COLOR = "#b2dfdb";
    private FONT_COLOR = "#333";
    
    constructor(props: ProjectAppMaterialGridProps) {
        super(props);
        this.state = {
            summarized: false,
            onlyParents: false,
            materialCustomButtonSettings: {
                summarize: true,
                unpack: true
            },
            deleteButton: true,
            editButton: true,
            gridData: [],
            showCopyDialog: false,
        };
        this.activateButton = true;
        this.enableUnpacked = false;
        this.dataUrl = "ProjectArticle/GetGridData?id=" + props.entity.Projnr;
        this.setOptions(this.state.summarized, this.state.onlyParents);
    }

    private getGridData = async () => {
        return new Promise<void>(async resolve => {
            const result = await HTTPService.get(this.dataUrl);

            this.gridData = result.Data.GridData;
            this.gridData.forEach(d => {
                d.Id = kendo.guid();
            });

            // Gefilterte GridData
            let filtertGridData: ProjectArticleViewModel[] = getFilteredGridData(this.state.summarized, this.state.onlyParents, this.gridData);

            this.setState({gridData: filtertGridData}, () => {
                resolve();
            });
        });
    }

    private openEditWindow = async (dataItem: ProjectArticleViewModel) => {

        const [result, metadata] = await Promise.all([
            HTTPService.get<JsonResultClass<ArticleEntity>>('ProjectArticle/Init?projNr=' + encodeURIComponent(this.props.entity.Projnr) + (Helper.hasValue(dataItem) ? "&pos=" + dataItem.Pos : "") + "&adrnr=" + this.props.entity.Adrnr),
            Helper.getMetaData("projectArticle")
        ]);

        const sheetTitle = Helper.getTranslation("Projekt.Material");
        const contextType = "projectArticleEdit";
        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(sheetTitle);
        sheet.bind(SheetEventType.SavedSuccessfully, async (target) => {
            await this.getGridData();
            $(window).trigger("projectArticlesAreChanged", { update: true });
            this.setState({});
        });
        sheet.show(() => {
            const entityCopy = result.Data;
            entityCopy.editAmount = dataItem.Summarized;
            const articleEditProps = {
                entity: entityCopy,
                metadata: metadata,
                context: {
                    key1: "entity.Projnr", keyVal1: this.props.entity.Projnr,
                    key2: "entity.Pos", keyVal2: ((this.props.entity) as any).Pos,
                    contextType: contextType
                },
                dataSources: {},
                isWindow: true,
                title: "",
                saveUrl: "ProjectArticle/SaveArticle",
            } as EditArticleAppProps;

            sheet.mountContent(EditArticle, articleEditProps);
        });
    }

    private create = async () => {
        const sheet = General.Sheet.Manager.createSheetWithUrl("DynamicSearch/Window/Article?multi=true&displayPattern=[[bezeichnung]]", { disableTabTitle: true });
        sheet.setTitle(Helper.getTranslation("Projekt.Material"));
        sheet.bind(SheetEventType.ItemsSelected, async (e: { data: Array<Article> }) => {


            if (Array.isArray(e.data) && e.data.length > 0) {
                const { Anzahl, Maschnr } = await OpenEditArticleDialog();

                let vorgangArtikelViewModelLst: ProjectArticleViewModel[] = [];
                for (let i = 0; i < e.data.length; i++) {
                    let vorgangArtikel = Helper.createEmptyEntity() as ProjectArticleViewModel;
                    vorgangArtikel.Id = kendo.guid();
                    vorgangArtikel.Artikelnummer = e.data[i].artikelnummer;
                    vorgangArtikel.Artikelnr = e.data[i].artnr;
                    vorgangArtikel.Anzahl = Anzahl;
                    vorgangArtikel.Datum = new Date();
                    vorgangArtikel.Produkt = e.data[i].produkt;
                    vorgangArtikel.Chargennr = e.data[i].chargennr;
                    vorgangArtikel.Seriennr = e.data[i].seriennr;
                    vorgangArtikel.EkPreis = e.data[i].ekpreis;
                    vorgangArtikel.Epreis = e.data[i].preis;
                    vorgangArtikel.Gpreis = e.data[i].preis * Anzahl;
                    vorgangArtikel.Kosten = e.data[i].ekpreis * Anzahl;
                    vorgangArtikel.Rabatt = 0;
                    vorgangArtikel.Projnr = this.props.entity.Projnr;
                    vorgangArtikel.Bezeichnung = e.data[i].bezeichnung;
                    vorgangArtikel.IsUnpacked = false;
                    vorgangArtikel.CanBeUnpacked = e.data[i].isassemblygroup;
                    vorgangArtikel.Summarized = false;
                    vorgangArtikel.Maschnr = Maschnr;
                    vorgangArtikelViewModelLst.push(vorgangArtikel);
                }
                await this.updateData(vorgangArtikelViewModelLst);
            }
        });
    }

    private updateData = async (data: ProjectArticleViewModel[]) => {
        const result = await HTTPService.post<JsonResultClass<ProjectArticleViewModel[]>>("ProjectArticle/SaveArticles", data);
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(result.Message);
            this.getGridData();
            $(window).trigger("projectArticlesAreChanged", { update: true });
        }
        else
            NotificationHelper.showErrorMessage(result.Message);
    }

    private open = (dataItem: any) => {
        this.openEditWindow(dataItem);
    }

    private remove = async (dataItem) => {
        if (dataItem.PIndex == null) {
            const isOk = await DialogHelper.confirm(this.props.translations["Standard.Msg.Loeschen"]);
            if (isOk) {
                const url = 'ProjectArticle/Delete?projNr=' + this.props.entity.Projnr + '&pos=' + dataItem.Pos;
                const result = await HTTPService.post(url);
                if (result.Code == 0) {
                    this.getGridData();
                    $(window).trigger("projectArticlesAreChanged", { update: true });
                }
                else
                    NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    //private createResourcePlanningSheet = (data: any) => {
    //    const url = Config.baseUrl + "ResourcePlanning/Edit?projNr=" + data.projNr + "&pIndex=" + data.pIndex;
    //    Helper.openInNewBrowserTab(url);
    //}

    private createInfo = () => {
        const style: React.CSSProperties = {
            display: "inline-block",
            color: this.FONT_COLOR,
            width: "240px",
            height: "auto",
            margin: "3px",
            padding: "5px",
            textAlign: "center",
            verticalAlign: "central",
            borderStyle: "solid",
            borderColor: this.FONT_COLOR,
            borderWidth: "1px",
            cursor: "default",
            borderRadius: "var(--border-radius)"
        };
        const style1: React.CSSProperties = { ...style, backgroundColor: this.ASSIGNMENT_BACKGROUND_COLOR }
        const style2: React.CSSProperties = { ...style, backgroundColor: this.WAREHOUSE_BACKGROUND_COLOR } 

        return (
            <div>
                <div className="servRepStatus" style={{ borderColor: this.FONT_COLOR, borderRadius: "var(--border-radius)" }}>
                    <span className="servRepStatus__title" style={{ color: this.FONT_COLOR }}>
                        {"Material"}
                    </span>
                    <br />
                    <div style={style1}>{Helper.getTranslation("Projekt.MappedToAssigment")}</div>
                    {this.warehouseActive ? < div style={style2}>{Helper.getTranslation("WebSMS.Warehouse.Available")}</div> : null}
                </div>
            </div>
        );
    }

    private onSelectionChanged = (dataItem: ProjectArticleViewModel) => {
        if (dataItem != null) {
            let canBeUnpacked = dataItem.CanBeUnpacked;
            this.enableUnpacked = Helper.hasValue(canBeUnpacked) ? canBeUnpacked : false;
            const enableButtons = !dataItem.Summarized && !dataItem.IsUnpacked;
            let newSettings = {
                summarize: !Helper.hasValue(dataItem.ResolvedFrom),
                unpack: this.state.materialCustomButtonSettings.unpack
            };

            this.setState({
                editButton: enableButtons && !dataItem.ReadOnly,
                deleteButton: enableButtons && !dataItem.ReadOnly,
                materialCustomButtonSettings: newSettings
            });
        }
    }

    private setOptions(summarized: boolean, onlyParents: boolean) {
        this.gridOptions = setOptions(summarized, onlyParents, this.props.context.materialGrid);
    }

    componentDidMount() {
        this.setEvents();
        this.checkEditability();
        this.getGridData();
    }

    private setEvents = () => {
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.Custom, (cus) => {
            if (cus.command === "projectStatusChanged") {
                this.activateButton = cus.value;
                this.setState({});
            }
        });
    }

    private checkEditability = () => {
        if (this.props.context.contextType === "project") {
            this.activateButton = this.props.entity.ProjectStatus.Editing;
            this.setState({});
        }
    }

    private onBtnClick = async (id: string, dataItem: ProjectArticleViewModel) => {
        switch (id) {
            case this.NEW_BTN_ID:
                this.create();
                break;
            case this.WAREHOUSE_BTN_ID:
                await this.openStockSearch();
                break;
            case this.EDIT_BTN_ID:
                this.open(dataItem);
                break;
            case this.DELETE_BTN_ID:
                this.remove(dataItem)
                break;
            case this.UNPACK_BTN_ID:
                this.unpackParts(dataItem);
                break;
            case this.MATERIAL_OVERVIEW_BTN_ID:
                this.openMaterialOverview(dataItem);
                break;
        }
        //if (id === "summarize") {
        //    this.summarizeParts(dataItem);
        //} 
    }

    private openStockSearch = async () => {
        const articles = await openStockSearch();
        if (articles.length == 0)
            return;
        const lst: ProjectArticleViewModel[] = articles.map((dataItem) => {
            return {
                Datum: new Date(),
                IsNew: true,
                IsWatchable: false,
                IsWatched: false,
                RecordRight: {
                    CanRead: true,
                    CanWrite: true
                },
                Anzahl: dataItem.amount,
                Artikelnr: dataItem.artNr,
                Artikelnummer: dataItem.article.articlenumber,
                Projnr: this.props.entity.Projnr,
                Id: kendo.guid(),
                Produkt: dataItem.article.product,
                Chargennr: dataItem.chargenNr,
                Seriennr: dataItem.serienNr,
                EkPreis: dataItem.article.ekpreis,
                Epreis: dataItem.article.preis,
                Gpreis: dataItem.article.preis * dataItem.amount,
                Kosten: dataItem.article.ekpreis * dataItem.amount,
                Rabatt: 0,
                Bezeichnung: dataItem.article.article,
                IsUnpacked: false,
                CanBeUnpacked: false,
                Summarized: false,
                Lagerid: dataItem.lagerId,
                Lagerplatzid: dataItem.lagerplatzId
            };
        });
        await this.updateData(lst);
    }

    private unpackParts = async (dataItem: ProjectArticleViewModel) => {
        // Kopf raus, Kinder rein
        let result = await HTTPService.post<JsonResultClass<boolean>>("ProjectArticle/UnpackAssemblyGroupPart", { parentPart: dataItem });
        if (result.Code === 0) {
            this.getGridData();
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    //private summarizeParts = async (dataItem: ProjectArticleViewModel) => {
    //    let result = await HTTPService.post<JsonResultClass<boolean>>("ProjectArticle/SummarizeArticles", { projnr: this.props.entity.Projnr, artNr: dataItem.Artikelnr });
    //    if (result.Code === 0) {
    //        this.getGridData();
    //    }
    //    else {
    //        NotificationHelper.showErrorMessage(result.Message);
    //    }
    //}

    private openMaterialOverview = async (dataItem: ProjectArticleViewModel) => {
        const metadata = await Helper.getMetaData("projectMaterialOverview");
        const props: ProjectMaterialOverviewProps = {
            entity: dataItem,
            context: {},
            title: "",
            metadata: metadata,
            dataSources: {},
            isWindow: false
        }
        let sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(Helper.getTranslation("WebSMS.SLA.Schedule") + " - " + dataItem.Artikelnummer + " - " + dataItem.Bezeichnung);
        sheet.show(() => {
            sheet.mountContent(ProjectMaterialOverview, props);
        });
    }

    private handleDataBound = (e) => {
        let data = e.sender.dataSource.view();
        for (var i = 0; i < data.length; i++) {
            const dataItem: ProjectArticleViewModel = data[i];
            const row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
            const cell = $("td", row);
            if (dataItem.AnzahlPlMat > 0) {
                $(row).css("background-color", this.ASSIGNMENT_BACKGROUND_COLOR);
                $(row).css("color", this.FONT_COLOR);
            } else if (this.warehouseActive && (Helper.hasValue(dataItem.Lagerid) && dataItem.Lagerid > 0) && (Helper.hasValue(dataItem.Lagerplatzid) && dataItem.Lagerplatzid > 0)) {
                $(row).css("background-color", this.WAREHOUSE_BACKGROUND_COLOR);
                $(row).css("color", this.FONT_COLOR);
            }
        }
    }

    private changeOptions = (newSummarized, newOnlyParents) => {
        let customButtonSettings = {
            summarize: !newSummarized,
            unpack: !newSummarized
        };;
        this.setOptions(newSummarized, newOnlyParents);

        let gridData = getFilteredGridData(newSummarized, newOnlyParents, this.gridData);

        this.setState({
            onlyParents: newOnlyParents,
            summarized: newSummarized,
            materialCustomButtonSettings: customButtonSettings,
            gridData: gridData
        });
    }

    render() {
        let warehouseBTN: GridCustomToolBarButton = null;

        //if (this.warehouseActive) {
        //    buttons.push(
        //        ,
        //    )
        //}
        if (this.warehouseActive)
            warehouseBTN = { autoEnabledOnRecordSelected: false, caption: Helper.getTranslation("WebSMS.Warehouse"), enabled: (this.props.entity.RecordRight.CanWrite && this.activateButton), iconClass: "fa-regular fa-warehouse", id: this.WAREHOUSE_BTN_ID };

        const buttons: Array<GridCustomToolBarButton> = [
            { autoEnabledOnRecordSelected: false, caption: Helper.getTranslation("Standard.Neu"), enabled: (this.props.entity.RecordRight.CanWrite && this.activateButton), iconClass: "k-i-plus", id: this.NEW_BTN_ID },
            warehouseBTN,
            { autoEnabledOnRecordSelected: true, caption: Helper.getTranslation("Standard.Editieren"), enabled: (this.props.entity.RecordRight.CanWrite && this.activateButton && this.state.editButton), iconClass: "k-i-pencil", id: this.EDIT_BTN_ID },
            { autoEnabledOnRecordSelected: true, caption: Helper.getTranslation("Standard.Loeschen"), enabled: (this.props.entity.RecordRight.CanWrite && this.activateButton && this.state.deleteButton), iconClass: "k-i-pencil", id: this.DELETE_BTN_ID },
            { autoEnabledOnRecordSelected: true, caption: Helper.getTranslation("Projekt.Unpack"), enabled: (this.props.entity.RecordRight.CanWrite && this.activateButton) && this.enableUnpacked && this.state.materialCustomButtonSettings.unpack, iconClass: "k-i-redo", id: this.UNPACK_BTN_ID },
            { autoEnabledOnRecordSelected: true, caption: Helper.getTranslation("WebSMS.SLA.Schedule"), enabled: (this.props.entity.RecordRight.CanRead && this.activateButton), iconClass: "fa-regular fa-circle-info", id: this.MATERIAL_OVERVIEW_BTN_ID }
        ].filter(btn => Helper.hasValue(btn));



        
        

        // Erstmal ausblenden da es sowieso kaum Anwendung finden könnte
        //customButtons.push({ autoEnabledOnRecordSelected: true, caption: this._translations["Projekt.SummarizeParts"], enabled: this.props.entity.RecordRight.CanWrite && this.state.materialCustomButtonSettings.summarize, iconClass: "k-i-redo", id: "summarize" });

        const content = <Grid
            data={this.state.gridData}
            options={this.gridOptions}
            id="projectMaterial"
            onSelectionChanged={this.onSelectionChanged}
            customButtons={buttons}
            onClickCustomButton={this.onBtnClick}
            onDataBound={this.handleDataBound}
        />

        return (
            <FullHeightContainer>
                {this.createInfo()}
                <AssemblyGroupViewElement changeOptions={this.changeOptions} onlyParents={this.state.onlyParents} summarized={this.state.summarized} />
                {content}
            </FullHeightContainer>
        );
    }
}

export interface ProjectArticleViewModel extends GridArticle {
    Projnr?: string;
    PIndex?: number;
    ReadOnly?: boolean;
}

interface ProjectAppMaterialState extends AppMaterialState {
}

export interface ProjectAppMaterialGridProps extends ProjectAppProps {
    translations: Array<string>;
}
